import { Component } from '@angular/core';

@Component({
  selector: 'mav-add-icon',
  templateUrl: './add-icon.component.html',
  styleUrls: ['./add-icon.component.scss']
})
export class AddIconComponent {

  constructor() { }
}
